export const NEW_INVITE_NOTIFICATION = 'invites.newInvitation';
export const NEW_EMPLOYER_INVITE_NOTIFICATION = 'invites.newEmployerInvitation';
export const SEND_INVITE_NOTIFICATION = 'invites.sendInvitation';
export const EDIT_EVENT_NOTIFICATION = 'calendar.editEvent';
export const NEW_EVENT_NOTIFICATION = 'calendar.newEvent';
export const MISS_EVENT_NOTIFICATION = 'calendar.didItFalse';
export const DELETE_EVENT_NOTIFICATION = 'calendar.deleteEvent';
export const CALENDAR_EVEVENTASSIGNMENT = 'calendar.eventAssignment';
export const CALENDAR_EMPLOYER_CHANGE_STATE = 'calendar.employerCalChangeState';
export const CALENDAR_EMPLOYER_PUBLISH_TO_CASES = 'calendar.employerCalPublishToCases';
export const AUTH_RESETPASSWORD = 'auth.resetPassword';
export const TEST_RESOURCE = 'TEST_RESOURCE';
export const CALENDAR_UPCOMING_ON_CALL = 'calendar.upcomingOnCall';
export const CALENDAR_ON_CALL = 'calendar.onCall';
export const MESSAGING_NEW_GROUP_MESSAGE_NOTIFICATION = 'messaging.newGroupMessage';
export const MESSAGING_NEW_BROADCAST_NOTIFICATION = 'messaging.newBroadcast';
